import { filter, map, pipe } from "rxjs"

export const filterFirstEmission = pipe(
    map((data: any,emission) => {        
      if(emission === 0){
        return null as unknown as Object
      }
      return data
    }),
    filter((variables) => !!variables)
)
